export default __webpack_public_path__ + "static/agile-project-management-065270eb2722ebc2a52762fbc0a1ddd2.mp4";